import request from "../../utils/request"

export function lock(data) {
    return request({
        url: '/service/mg/common/lock',
        method: 'post',
        data
    })
}

export function unlock(data) {
    return request({
        url: '/service/mg/common/unlock',
        method: 'post',
        data
    })
}
